// @ts-nocheck

import React, { useEffect, useState } from "react";
import axios from "axios";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LOGO } from "../assets/images";
import { useAppDispatch } from "../hooks/useRedux";
import { saveAthleticInfo } from "../store/userSlice";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { BASE_URL } from "../Constants/BaseUrl";

const genderOptions = [
  { label: "Male", value: "Male" },
  { label: "Female", value: "Female" },
];

const schoolYearOptions = [
  { label: "Freshman", value: "Freshman" },
  { label: "Sophomore", value: "Sophomore" },
  { label: "Junior", value: "Junior" },
  { label: "Senior", value: "Senior" },
];

const divisionOptions = [
  { label: "D1", value: "D1" },
  { label: "D2", value: "D2" },
  { label: "D3", value: "D3" },
  { label: "NAIA", value: "NAIA" },
  { label: "Junior College", value: "Junior College" },
];

const CompleteProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const studentID = location.state?.student_athlete_id;
  console.log("student ID in complete screen: ", studentID);
  const dispatch = useAppDispatch();

  const [form, setForm] = useState({
    username: "",
    first_name: "",
    last_name: "",
    dob: "",
    gender: "",
    weight: "",
    height: "",
    current_school: "",
    sport_id: "",
    position: "",
    school_year: "",
    division: "",
  });

  const [sports, setSports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [prevHeight, setPrevHeight] = useState("");

  const getSports = () => {
    axios
      .get(`${BASE_URL}sports/all`)
      .then((res) => setSports(res.data.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getSports();
  }, []);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };
  const handleChangeForHeight = (text) => {
    let cleaned = text.replace(/[^0-9']/g, "");

    if (
      cleaned.length === 1 &&
      prevHeight.length < cleaned.length &&
      !cleaned.includes("'")
    ) {
      cleaned = `${cleaned}'`;
    }

    const parts = cleaned.split("'");
    if (parts.length > 2) {
      return;
    }

    if (parts.length === 2) {
      parts[1] = parts[1].slice(0, 2);
      cleaned = parts[0] + "'" + parts[1];
    }

    setPrevHeight(cleaned);
    setForm((prev) => ({ ...prev, height: cleaned }));

    const isValid = /^(\d)'(\d{1,2})$/.test(cleaned);
  };

  const validateForm = () => {
    for (const key in form) {
      if (!form[key]) {
        toast.error(`Please fill out the ${key} field.`);
        return false;
      }
    }
    return true;
  };

  const handleSaveDetails = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);
      const payload = {
        ...form,
        fcm_token: "",
        athlete_id: location.state.student_athlete_id,
      };

      console.log("Payload:", payload);

      const result = await dispatch(saveAthleticInfo(payload)).unwrap();

      console.log("Returned API Data:", result);

      navigate("/welcome", { state: { userInfo: result } });

      toast.success("Profile saved successfully");
    } catch (error) {
      console.error(error);
      toast.error(error ? error : "Something went wrong");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-screen bg-[#121212] text-white p-4">
      <ToastContainer />

      <h2 className="text-center text-lg font-semibold uppercase mb-4">
        Tell us about yourself
      </h2>
      <p className="text-sm mb-6 max-w-xl mx-auto text-center">
        The following information will be published to your profile. This allows
        coaches and colleges to find and view your details for potential
        recruitment.
      </p>

      <div className="max-w-xl mx-auto space-y-4">
        {[
          "username",
          "first_name",
          "last_name",
          "weight",
          "current_school",
          "position",
        ].map((key) => (
          <input
            key={key}
            type={key === "weight" ? "number" : "text"}
            placeholder={key.replace(/_/g, " ")}
            value={form[key]}
            onChange={(e) => {
              const value = e.target.value;
              if (key === "weight" && !/^\d*$/.test(value)) return;
              handleChange(key, value);
            }}
            className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] border border-gray-600 text-white placeholder-gray-400"
          />
        ))}

        <input
          type="text"
          placeholder="Height (e.g., 5'11)"
          value={form.height}
          onChange={(e) => handleChangeForHeight(e.target.value)}
          className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] border border-gray-600 text-white placeholder-gray-400"
        />

        <StyledDateInput
          type="date"
          value={form.dob}
          onChange={(e) => handleChange("dob", e.target.value)}
          className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] border border-gray-600 text-white placeholder-gray-400"
        />

        <select
          value={form.gender}
          onChange={(e) => handleChange("gender", e.target.value)}
          className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] border border-gray-600 text-white"
        >
          <option value="" disabled>
            Select Gender
          </option>
          {genderOptions.map((g) => (
            <option key={g.value} value={g.value} className="text-white">
              {g.label}
            </option>
          ))}
        </select>

        <select
          value={form.sport_id}
          onChange={(e) => handleChange("sport_id", e.target.value)}
          className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] border border-gray-600 text-white"
        >
          <option value="" disabled>
            Select Sport
          </option>
          {sports.map((s) => (
            <option key={s.id} value={s.id} className="text-white">
              {s.sport_name}
            </option>
          ))}
        </select>
        <select
          className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] border border-gray-600 text-white"
          value={form.division}
          onChange={(e) => handleChange("division", e.target.value)}
        >
          <option value="" disabled hidden>
            Division
          </option>
          {divisionOptions.map((opt) => (
            <option key={opt.value} value={opt.value} className="text-white">
              {" "}
              {opt.label}
            </option>
          ))}
        </select>

        <select
          value={form.school_year}
          onChange={(e) => handleChange("school_year", e.target.value)}
          className="w-full px-4 py-3 rounded-md bg-[#2a2a2a] border border-gray-600 text-white"
        >
          <option value="" disabled>
            Select School Year
          </option>
          {schoolYearOptions.map((s) => (
            <option key={s.value} value={s.value} className="text-white">
              {s.label}
            </option>
          ))}
        </select>

        <button
          onClick={handleSaveDetails}
          disabled={loading}
          className="w-full bg-[#C00000] hover:bg-red-700 text-white py-3 rounded-md font-semibold"
        >
          {loading ? "Saving..." : "Save Details"}
        </button>
      </div>
    </div>
  );
};

const StyledDateInput = styled.input`
  &[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(100%);
  }
`;

export default CompleteProfile;
